import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface CreateEventAlertDialogProps {
  isOpen: boolean;
  editMode: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (skipGcrValidation: boolean) => void;
}

export function CreateEventAlertDialog({
  isOpen,
  editMode,
  onSubmit,
  onOpenChange,
}: CreateEventAlertDialogProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Are sure you want to {editMode ? 'update' : 'create'} this event?
          </AlertDialogTitle>
          <AlertDialogDescription>
            Where are some models without GCR file.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => onSubmit(true)}
            className="text-destructive border-destructive hover:text-destructive min-w-[150px]"
            data-testid="submit-button"
          >
            {editMode ? 'Save Changes' : 'Create new event'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
